export default __webpack_public_path__ + "static/media/icon-button.510f85c7.svg";